var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1201,
    height: 915,
    viewBox: "0 0 1201 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924 512C924 613.068 845.069 695 747.704 695C650.338 695 584.5 613.068 584.5 512C584.5 410.932 650.338 329 747.704 329C845.069 329 924 410.932 924 512Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889 503C889 583.634 823.319 649 742.296 649C661.274 649 656 583.634 656 503C656 422.366 661.274 357 742.296 357C823.319 357 889 422.366 889 503Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_27_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693 423C693 503.634 627.319 569 546.296 569C465.274 569 460 503.634 460 423C460 342.366 465.274 277 546.296 277C627.319 277 693 342.366 693 423Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_27_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510 525C510 605.634 444.319 671 363.296 671C282.274 671 277 605.634 277 525C277 444.366 282.274 379 363.296 379C444.319 379 510 444.366 510 525Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_11",
    x: 308.1,
    y: 52.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_27_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27_11",
    x: 379.6,
    y: 80.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_27_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_27_11",
    x: 183.6,
    y: 0.600006,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_27_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_27_11",
    x: 0.600006,
    y: 102.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_27_11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGlow);
export default __webpack_public_path__ + "static/media/home_glow.26e71897b7cc07cb69f562aa36e295fd.svg";
export { ForwardRef as ReactComponent };